export const shortcutKeysExcludeList: ReadonlyArray<string> = [
    "enter",
    "shift+enter",
    "esc",
    "arrowup",
    "arrowdown",
    "arrowleft",
    "arrowright",
    "alt+0",
    "tab",
    "shift+tab",
    "space"
];
